/* assets/giddy-video-sound.js
   Giddy — minimal video sound control (no native player chrome).

   - A single mute/unmute button sits on the video; no play/pause/scrub bar.
   - Desktop (hover-capable pointers): hovering the video turns the sound ON and
     leaving turns it back off — unless the visitor has taken manual control
     with the button, in which case their choice sticks.
   - Clicking / tapping the video itself pauses or resumes it.
*/
(function () {
  'use strict';

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init(wrap) {
    if (wrap.dataset.giddySoundInit) return;
    wrap.dataset.giddySoundInit = '1';

    var video = wrap.querySelector('video');
    if (!video) return;
    var btn = wrap.querySelector('[data-giddy-sound-toggle]');
    var manual = false; // visitor has explicitly chosen a sound state

    function setMuted(m) {
      video.muted = m;
      wrap.classList.toggle('is-unmuted', !m);
      if (btn) {
        btn.setAttribute('aria-pressed', String(!m));
        btn.setAttribute('aria-label', m ? 'Unmute video' : 'Mute video');
      }
      // Some browsers pause an autoplaying video the moment it is unmuted
      // without a click — nudge it back into play if that happens.
      if (!m && video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    setMuted(true);

    if (canHover) {
      wrap.addEventListener('mouseenter', function () {
        if (!manual) setMuted(false);
      });
      wrap.addEventListener('mouseleave', function () {
        if (!manual) setMuted(true);
      });
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        manual = true;
        setMuted(!video.muted);
      });
    }

    // Press the video to pause / resume.
    video.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    });
  }

  function run() {
    document.querySelectorAll('[data-giddy-sound]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
